export enum CreateTourStep {
  detailsStep = 1,
  usersStep = 2,
  locationStep = 3,
  scheduleStep = 4,
  reviewStep = 5,
  providerStep = 6,
};